/**
 * Chipy filtrow (GET /kontrola-korekt/lista?filtr=...) + select sklepu (z per_sklep) + szukaj po numerze.
 *
 * Zaznaczony chip = PELNE tlo + kolor #fff ustawione INLINE - motyw wymusza
 * !important na przyciskach, a wyjatek :not([style*="background"]) w
 * v3sys-theme.css dziala tylko dla inline background. Nie zamieniac na klasy.
 */
import React from 'react';
import { FILTRY_KOREKT } from './format';

const WSZYSTKIE = '';

const FiltryKorekt = ({ filtr, onFiltr, szukaj, onSzukaj, liczby, perSklep, sklepId, onSklep }) => {
  const l = liczby || {};
  const sklepy = (Array.isArray(perSklep) ? perSklep : []).filter(s => s.sklep_id !== null && s.sklep_id !== undefined);

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '6px', fontSize: '12px' }}>
      <div role="group" aria-label="Filtr" style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
        {FILTRY_KOREKT.map(f => {
          const aktywny = f.id === filtr;
          const licznik = f.licznik && l[f.licznik] !== undefined && l[f.licznik] !== null ? ` (${l[f.licznik]})` : '';
          return (
            <button
              key={f.id}
              type="button"
              data-testid={`filtr-${f.id}`}
              aria-pressed={aktywny}
              onClick={() => onFiltr(f.id)}
              style={{
                padding: '4px 10px', fontSize: '11px', fontWeight: 600, borderRadius: '12px', cursor: 'pointer',
                border: `1px solid ${f.kolor}`,
                background: aktywny ? f.kolor : 'var(--card-bg)',
                color: aktywny ? '#fff' : f.kolor,
              }}
            >
              {f.etykieta}{licznik}
            </button>
          );
        })}
      </div>
      <div style={{ marginLeft: 'auto', display: 'flex', gap: '6px', alignItems: 'center', flexWrap: 'wrap' }}>
        {onSklep && (
          <label style={{ fontSize: '11px', color: 'var(--text-secondary)', whiteSpace: 'nowrap' }}>
            Sklep{' '}
            <select
              aria-label="Sklep"
              data-testid="filtr-sklep"
              value={sklepId === null || sklepId === undefined ? WSZYSTKIE : String(sklepId)}
              onChange={(e) => onSklep(e.target.value === WSZYSTKIE ? null : Number(e.target.value))}
              style={{ padding: '4px 8px', fontSize: '11px', borderRadius: '4px', border: '1px solid var(--border)', backgroundColor: 'var(--card-bg)', color: 'var(--text)' }}
            >
              <option value={WSZYSTKIE}>wszystkie sklepy</option>
              {sklepy.map(s => (
                <option key={s.sklep_id} value={String(s.sklep_id)}>{s.nazwa}{s.wszystkie !== undefined ? ` (${s.wszystkie})` : ''}</option>
              ))}
            </select>
          </label>
        )}
        <input
          type="search"
          value={szukaj}
          onChange={(e) => onSzukaj(e.target.value)}
          placeholder="Szukaj po numerze…"
          aria-label="Szukaj po numerze"
          style={{ padding: '4px 8px', fontSize: '11px', borderRadius: '4px', minWidth: '220px', border: '1px solid var(--border)', backgroundColor: 'var(--card-bg)', color: 'var(--text)' }}
        />
      </div>
    </div>
  );
};

export default FiltryKorekt;
